import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../../reactQueryFetcherAdapters";
import { freeTrialValidateSmsCacheKeys } from "./constants";
import type { ValidateSmsPayload } from "./types";

export const validateSms = reactQueryMutationAdapter(
  freeTrialValidateSmsCacheKeys,
  async (payload: ValidateSmsPayload): Promise<any> => {
    return fetch(`/free_trial/validate_sms`, "POST", payload, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
